export const dropdownBaseToggleExpandedSymbol = Symbol('Dropdown Base toggle expanded');
